import React, { useState, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, List, ListItem, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getReleaseNotes } from '../features/releaseNotes/services/releaseNotesService';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';

const ReleaseNotesPage = () => {
  const [releaseNotes, setReleaseNotes] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedReleaseNotes = await getReleaseNotes();
        if (fetchedReleaseNotes && Array.isArray(fetchedReleaseNotes)) {
          setReleaseNotes(fetchedReleaseNotes);
          enqueueSnackbar(
            <FormattedMessage
              id="releaseNotes.get.msg.success"
              defaultMessage="Release notes successfully fetched"
            />,
            { variant: 'success' }
          );
        } else {
          throw new Error('Invalid data format received');
        }
      } catch (error) {
        setReleaseNotes([]);
        enqueueSnackbar(
          <FormattedMessage
            id="releaseNotes.get.msg.error"
            defaultMessage="Release notes fetch failed"
          />,
          { variant: 'error' }
        );
      }
    };

    fetchData();
  }, [enqueueSnackbar]);

  return (
    <Box sx={{ maxWidth: '900px', margin: 'auto', padding: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Release Notes
      </Typography>
      {releaseNotes.length > 0 ? (
        releaseNotes.map((release) => (
          <Box key={release.id} sx={{ marginBottom: '20px' }}>
            <Typography variant="h5" gutterBottom>
              <strong>{release.version}</strong> - Released on {new Date(release.releaseDate).toLocaleDateString()}
            </Typography>
            {release.sections?.map((section) => (
              <Accordion key={section.id} sx={{ marginBottom: '10px' }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel-${section.id}-content`}
                  id={`panel-${section.id}-header`}
                >
                  <Typography variant="h6">{section.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <List>
                    {section.items?.map((item) => (
                      <ListItem key={item.id}>
                        <ListItemText primary={item.description} />
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))
      ) : (
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          <FormattedMessage
            id="releaseNotes.empty"
            defaultMessage="There are currently no release notes available."
          />
        </Typography>
      )}
    </Box>
  );
};

export default ReleaseNotesPage;
